export default __webpack_public_path__ + "static/media/stop.b9b09970.svg";